import React, { useState, Fragment } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { Provider, connect } from 'react-redux'
import {Router as Router, Route, Link, useParams, useLocation} from "react-router-dom";
import MBMap from './map/MBMap';
import ViewportMapContainer from './map/ViewportMapContainer';
import MainMenuContainer from './containers/MainMenuContainer';
import MenuToggleOverlayContainer from './containers/MenuToggleOverlayContainer';
import ExtraMapFeatures from './map/ExtraMapFeatures'
import DisplayTimeOverlay from 'DisplayTimeOverlay'
import PlaybackController from 'PlaybackController';

import { useNavigate } from "react-router-dom";

//<div> 
//{/* overlay elements for sidebar and chart switchers */}
//<div> {/*style="display: flex"*/}
//  <div id="chartSwitcherOverlay" hidden></div>
//</div>
//{/* overlay window for timer  class="position-absolute ml-2 mt-2" style="padding-top: 70px; width: 160px; z-index:900;" */}
//<div id="timerOverlay" ></div>
//{/* overlay window for comparison timer class="position-absolute ml-2 mt-5" style="padding-top: 70px; width: 160px; z-index:900;" */}
//<div id="comparisonTimerOverlay"></div>
//    
//</div>


export default function App (props) {
  //console.log("rendering App")

  var mapLogo = ""
  if ((typeof MAP_LOGO !== "undefined") )  {
    mapLogo = 
      <div id="logo1">
        <img src={MAP_LOGO}></img>
      </div>
  }
  return (
  <Container fluid className="h-100 p-0"> {/* class="container-fluid h-100"  className="p-3" */}
    <Row className="h-100 p-0"> {/* <div id="main-row" class="row h-100"></div> */}
      {/*<div id="sidebar" class="col-sm-3 col-md-2 card m-0 p-0" role="navigation" >*/}
      <Col className="h-100 p-0">  {/* main content with map: 
                 <div id="mainCol" class="card d-flex fill m-0 p-0 h-100"> */}

        {/* map container with chart */}
        {/*  fill d-flex justify-content-start"> */}
        <div id="map" className="h-100 p-0"/>

        <Provider store={props.store}>
          {/*<Router basename={props.basename} >
             <RouteLogger/>
            <Route path="/" render={({ location }) =>  
            browserHistory={useNavigate()} 
            browserHistory={props.history}
          */}
              <>
                {/* ViewportBlock  */}
                
                <MainMenuContainer
                    location={location}/>

                <ViewportMapContainer
                    location={location}
                    initialSubview={props.initialSubview}
                />
                <ExtraMapFeatures  
                    location={location} 
                    initialSubview={props.initialSubview}
                />

                <div id='mapOverlayTopLeftColumn'>
                  <div id="menuToggleOverlay">
                    <MenuToggleOverlayContainer/>
                  </div>
                  <div id="timerOverlay" >
                    <DisplayTimeOverlay/>
                  </div>
                </div>

                <MBMap
                  location={location}
                  afterMapInitialization={props.afterMapInitialization}
                  initialSubview={props.initialSubview}/>
                
                {
                <PlaybackController 
                  initialSubview={props.initialSubview} 
                />
                }
              </>
            {/*} />
          </Router>*/}
        </Provider>
        
        <div id="chart" hidden></div>
        <div id="moLogo">
          <a href="//movingobject.co" target="_blank">
            <img className="mx-auto d-block pl-3 pr-3 pt-1 pb-1" src="//movingobject.co/img/logo-inline.png" alt="movingobject.co" />
          </a>
        </div>
        { mapLogo }        
        {/*<div id="logo1-text">
          ÉMOP-2.1.1/A-12-K2-2012-0002
        </div>
        <div id="logo2">
          <img src="//movingobject.co/img/keknap/logo-uszt.svg"></img>
        </div>*/}
      </Col>

    </Row>
  </Container>
  )
};

//function RouteLogger() {
//  const location = useLocation();
//  const params = useParams();
//  let query =  (new URLSearchParams(location.search));
//  console.log("location.pathname:", location.pathname, 
//              "whatsup:", query.get("whatsup"), 
//              "params:", params );
//
//  return null 
//}